import React, { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import $ from "jquery";
import { IconButton } from "./IconButton";
import { jsonHeaders, msHeaders } from "./NavMenu";
import { Previewer } from "./Previewer";
import { Seperator } from "./Seperator";
import "./css/DeviceInfoModal.css";
import { useTranslation } from "react-i18next";

export function DeviceInfoModal({ device, shown, closeModal }) {
    const { t } = useTranslation();
    const [playlists, setPlaylists] = useState([]);
    const [curPlaylist, setCurPlaylist] = useState(null);
    const [newPlaylist, setNewPlaylist] = useState(null);
    const [curInterval, setCurInterval] = useState(0);
    const [intervalText, setIntervalText] = useState("");
    const [statusChanged, setStatusChanged] = useState(false);
    const [deviceName, setDeviceName] = useState("");
    const [previewerEnabled, setPreviewerEnabled] = useState(false);
    const [order, setOrder] = useState([]);
    const [newOrder, setNewOrder] = useState([]);
    const [previewerOrder, setPreviewerOrder] = useState([]);
    const [pictures, setPictures] = useState([]);
    const [newPictures, setNewPictures] = useState([]);
    const [previewerPictures, setPreviewerPictures] = useState([]);
    const [previewerShown, setPreviewerShown] = useState(false);
    const [curLoc, setCurLoc] = useState(null);
    const [newLoc, setNewLoc] = useState(null);
    const [locationList, setLocationList] = useState([]);
    const [firmwares, setFirmwares] = useState([]);

    useEffect(() => {
        if (shown) {
            $("#more-modal-container").fadeIn(300);
            $("#more-modal-container").css("display", "flex");
            $("#more-modal").css({ "margin-left": "2000px" }).animate({ "margin-left": "0px" }, 300);
            fetchDevice();
        }
    }, [shown]);

    async function fetchDevice() {
        if (device == null) return;

        const playlists = await fetchPlaylists();
        setPlaylists(playlists);
        const locationList = await fetchLocationList();
        setLocationList(locationList);
        const firmwares = await fetchFirmwares();
        setFirmwares(firmwares);

        var requestOptions = {
            method: "GET",
            headers: msHeaders,
            redirect: "follow",
        };
        fetch(`/api/devices/${device.uuid}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                console.log(result);
                const playlist = playlists.find((p) => p.uuid == result.playlistUUID);
                setCurPlaylist(playlist);
                setNewPlaylist(null);
                setCurInterval(Number(result.interval));
                updateIntervalText(Number(result.interval));
                setStatusChanged(false);
                setDeviceName(result.name);
                const location = locationList.find((l) => l.uuid == result.locationUUID);
                setCurLoc(location);
                setNewLoc(null);
                // setPreviewerEnabled(false);
                // fetchPlaylist(result.playlistUUID);
            });
    }

    async function fetchPlaylists() {
        var requestOptions = {
            method: "GET",
            headers: msHeaders,
            redirect: "follow",
        };
        const response = await fetch(`/api/playlists/`, requestOptions);
        const result = await response.json();
        return result;
    }

    // function fetchPlaylist(uuid) {
    //     if (!uuid) {
    //         setPlaylistName("");
    //         return;
    //     }
    //     var requestOptions = {
    //         method: 'GET',
    //         headers: msHeaders,
    //         redirect: 'follow'
    //     };

    //     fetch(`/api/playlists/${uuid}`, requestOptions)
    //         .then(response => response.json())
    //         .then(result => {
    //             setPlaylistName(result.name);
    //             setOrder(JSON.parse(result.order));
    //         })

    //     fetch(`/api/playlists/${uuid}/pictures`, requestOptions)
    //         .then(response => response.json())
    //         .then(result => {
    //             setPictures(result);
    //         })
    // }

    async function fetchLocationList() {
        var requestOptions = {
            method: "GET",
            headers: msHeaders,
            redirect: "follow",
        };
        const response = await fetch(`/api/locations`, requestOptions);
        const result = await response.json();
        return result;
    }

    async function fetchFirmwares() {
        var requestOptions = {
            method: "GET",
            headers: msHeaders,
            redirect: "follow",
        };
        const response = await fetch(`/epd/devices/${device.uuid}/deviceInfo`, requestOptions);
        const result = await response.json();
        return result.firmware;
    }

    // function handleDownload() {
    //     if (!curPlaylist)
    //         return;
    //     const url = `/api/devices/${device.id}/content`;

    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = "";
    //     //link.target = '_blank';

    //     link.click();
    //     link.remove();
    // }

    // function handlePreview(source) {
    //     if (source == 'current') {
    //         setPreviewerPictures(pictures);
    //         setPreviewerOrder(order);
    //     }
    //     else {
    //         setPreviewerPictures(newPictures);
    //         setPreviewerOrder(newOrder);
    //     }
    //     setPreviewerShown(true);
    // }

    function showMenu(menuId) {
        $(`#${menuId}`).css("display", "flex");
    }

    function selectPlaylist(playlist) {
        $("#playlist-menu").hide();
        // order = JSON.parse(playlist.order);
        setNewPlaylist(playlist);
        if (playlist == curPlaylist) return;
        setStatusChanged(true);
        // setNewOrder(playlist.order);

        // var requestOptions = {
        //     method: 'GET',
        //     headers: msHeaders,
        //     redirect: 'follow'
        // };

        // fetch(`/api/playlists/${playlist.uuid}/pictures`, requestOptions)
        //     .then(response => response.json())
        //     .then(result => {
        //         if (!result.length) {
        //             setPreviewerEnabled(false);
        //             return;
        //         }
        //         setNewPictures(result);
        //         setPreviewerEnabled(true);
        //     })
    }

    function selectLocation(location) {
        $("#new-location-menu").hide();
        setNewLoc(location);
        if (location.name == curLoc) return;
        setStatusChanged(true);
    }

    function handleSlide(value) {
        setStatusChanged(value != curInterval);
    }

    function handleSave() {
        if (!statusChanged) return;

        const option = $("#interval-option").val();
        const value = Number($("#interval-value").val());
        let newInterval = 0;
        switch (option) {
            case "weeks":
                newInterval = value * 7 * 24 * 60;
                break;
            case "days":
                newInterval = value * 24 * 60;
                break;
            case "hours":
                newInterval = value * 60;
                break;
            case "minutes":
                newInterval = value;
                break;
            default:
                newInterval = 60;
                break;
        }
        if (newInterval && newInterval < 5) {
            alert("Interval time cannot less than 5 minutes.");
            return;
        }

        if (!window.confirm("This will change the playlist of the client device.")) {
            return;
        }

        var requestOptions = {
            method: "PUT",
            headers: jsonHeaders,
            body: JSON.stringify({
                name: deviceName,
                playlistId: newPlaylist ? newPlaylist.uuid : curPlaylist?.uuid,
                interval: newInterval ? newInterval : curInterval,
                locationId: newLoc ? newLoc.uuid : curLoc?.uuid,
            }),
            redirect: "follow",
        };

        fetch(`/api/devices/${device.uuid}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (!result.id) {
                    alert(result);
                    return;
                }
                setCurInterval(newInterval);
                setCurPlaylist(newPlaylist);
                setCurLoc(newLoc?.name);
                setStatusChanged(false);
                fetchDevice();
            });
    }

    function updateIntervalText(minutes) {
        let value;
        const option = $("#interval-option").val();
        switch (option) {
            case "weeks":
                value = minutes / 60 / 24 / 7;
                break;
            case "days":
                value = minutes / 60 / 24;
                break;
            case "hours":
                value = minutes / 60;
                break;
            case "minutes":
                value = minutes;
                break;
            default:
                value = minutes;
                break;
        }
        setIntervalText(`${Math.round(value * 100) / 100} ${option}`);
    }

    return (
        <>
            <div
                className="device-info-container"
                id="more-modal-container"
                onClick={(event) => {
                    var $target = $(event.target);
                    if (
                        !$target.closest("#more-modal").length &&
                        $("#more-modal-container").is(":visible") &&
                        !$("#previewer-container").is(":visible")
                    ) {
                        closeModal();
                        $("#more-modal-container").fadeOut(300);
                        $("#more-modal").css("margin-left", "0px").animate({ "margin-left": "2000px" }, 300);
                    }
                    if (!$target.closest("#playlist-menu").length && $("#playlist-menu").is(":visible")) {
                        $("#playlist-menu").hide();
                    }
                    if (!$target.closest("#new-location-menu").length && $("#new-location-menu").is(":visible")) {
                        $("#new-location-menu").hide();
                    }
                }}
            >
                <div
                    className="device-info"
                    id="more-modal"
                    onClick={(e) => {
                        e.stopPropagation();
                        var $target = $(e.target);
                        if (!$target.closest("#playlist-menu").length && $("#playlist-menu").is(":visible")) {
                            $("#playlist-menu").hide();
                        }
                        if (!$target.closest("#new-location-menu").length && $("#new-location-menu").is(":visible")) {
                            $("#new-location-menu").hide();
                        }
                    }}
                >
                    <div className="bar">
                        <div className="info-title">{t("device-deviceName")}:</div>
                        <input
                            id={"device-name-edit"}
                            type="text"
                            className="form-control text-18pt"
                            value={deviceName}
                            style={{ color: "#094EFF", border: "white" }}
                            onChange={(e) => {
                                setDeviceName(e.target.value);
                            }}
                            onBlur={(e) => {
                                setStatusChanged(true);
                            }}
                        />
                        <IconButton
                            onClick={() => {
                                document.getElementById("device-name-edit").focus();
                            }}
                            src="icons/edit.svg"
                            srcWhite="icons/edit-white.svg"
                        />
                    </div>
                    <Seperator width={726} />
                    {[t("device-model"), t("device-orientation"), t("device-sn"), t("device-uuid")].map((title) => {
                        if (!device) return;
                        return (
                            <div className="bar" key={title}>
                                <div className="info-title">{title}:</div>
                                <div className="text-16pt">
                                    {title == t("device-model") ? device.model : ""}
                                    {title == t("device-orientation")
                                        ? (device.orientation % 180 == 0 ? "Landscape " : "Portrait ") + `${device.orientation}°`
                                        : ""}
                                    {title == t("device-sn") ? device.sn : ""}
                                    {title == t("device-uuid") ? device.uuid : ""}
                                </div>
                            </div>
                        );
                    })}
                    <Seperator width={726} />
                    <div className="bar">
                        <div className="info-title text-nowrap">{t("device-current-location")}:</div>
                        <div className="text-16pt" style={{ width: "416px" }}>
                            {curLoc?.name}
                        </div>
                    </div>
                    <div className="bar">
                        <div className="info-title">{t("device-new-location")}:</div>
                        <div
                            className="selector-container"
                            onClick={(e) => {
                                e.stopPropagation();
                                showMenu("new-location-menu");
                            }}
                        >
                            <div className="text-placeholder" id="placeholder">
                                {newLoc ? newLoc.name : "select location"}
                            </div>
                            <img src="icons/arrow-down-big.svg" className="icon" />
                        </div>
                        <div className="playlist-menu" id="new-location-menu">
                            {locationList.map((loc, index) => {
                                return (
                                    <div key={index}>
                                        {loc != locationList[0] ? <Seperator width={412} style={{ margin: "6px 0px" }} /> : <></>}
                                        <div
                                            className="playlist-name"
                                            onClick={() => {
                                                selectLocation(loc);
                                            }}
                                        >
                                            {loc.name}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <Seperator width={726} style={{ marginTop: "10px" }} />
                    <div className="bar">
                        <div className="info-title">{t("device-current-playlist")}:</div>
                        <div className="text-16pt" id="modal-playlist-name" style={{ width: "416px" }}>
                            {curPlaylist?.name}
                        </div>
                        {/* <IconButton
                            onClick={() => { handleDownload() }}
                            src="icons/download-2.svg"
                            srcWhite="icons/download-2-white.svg"
                        />
                        <IconButton
                            onClick={() => { handlePreview('current') }}
                            src="icons/preview.svg"
                            srcWhite="icons/preview-white.svg"
                        /> */}
                    </div>
                    <div className="bar">
                        <div className="info-title">{t("device-interval")}:</div>
                        <div className="text-16pt" id="modal-interval">
                            {intervalText} / per slide
                        </div>
                    </div>
                    <div className="bar">
                        <div className="info-title">{t("device-new-playlist")}:</div>
                        <div
                            className="selector-container"
                            onClick={(e) => {
                                e.stopPropagation();
                                showMenu("playlist-menu");
                            }}
                        >
                            <div className="text-placeholder" id="placeholder">
                                {newPlaylist ? newPlaylist.name : "select playlist"}
                            </div>
                            <img src="icons/arrow-down-big.svg" className="icon" />
                        </div>
                        <div className="playlist-menu" id="playlist-menu">
                            {playlists.map((playlist, index) => {
                                return (
                                    <div key={index}>
                                        {playlist != playlists[0] ? (
                                            <Seperator width={412} style={{ margin: "6px 0px" }} />
                                        ) : (
                                            <></>
                                        )}
                                        <div
                                            className="playlist-name"
                                            onClick={() => {
                                                selectPlaylist(playlist);
                                            }}
                                        >
                                            {playlist.name}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {/* <IconButton
                            className="disabled"
                            onClick={() => { handlePreview('new') }}
                            src="icons/preview.svg"
                            srcWhite="icons/preview-white.svg"
                            disabled={!previewerEnabled}
                            disabledIcon="icons/preview-disabled.svg"
                        /> */}
                    </div>
                    <div className="bar">
                        <div className="info-title">{t("device-new-interval")}:</div>
                        <div className="slide-container">
                            <input
                                id="interval-value"
                                type="number"
                                style={{ width: "100px" }}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}
                                onChange={(e) => {
                                    setStatusChanged(true);
                                }}
                            />
                            <select
                                id="interval-option"
                                class="form-select form-select-sm mx-3"
                                aria-label=".form-select-lg"
                                style={{ width: "150px" }}
                                defaultValue={"days"}
                                onChange={() => {
                                    setStatusChanged(true);
                                    updateIntervalText(curInterval);
                                }}
                            >
                                {["weeks", "days", "hours", "minutes"].map((option) => {
                                    return <option>{option}</option>;
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="bar">
                        <div
                            className="button-container button-text"
                            style={
                                statusChanged
                                    ? {}
                                    : {
                                          background: "#808080",
                                          border: "none",
                                          color: "#FFF",
                                          cursor: "no-drop",
                                      }
                            }
                            onClick={() => {
                                handleSave();
                            }}
                        >
                            Save Changes
                        </div>
                    </div>
                    <div className="bar">
                        <div className="info-title">{t("device-firmware")}</div>
                        <div className="text-16pt">{t("device-fw-version")}</div>
                    </div>
                    <Seperator width={726} />
                    {firmwares.map((fw) => {
                        return (
                            <div className="bar" key={fw.uuid}>
                                <div className="info-title">{fw.name}</div>
                                <div className="text-16pt">{fw.version}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <Previewer
                shown={previewerShown}
                pictures={previewerPictures}
                order={previewerOrder}
                close={() => {
                    setPreviewerShown(false);
                }}
            />
        </>
    );
}
